import React from 'react';

import TeacherListItem from 'components/teachers/TeacherListItem';

class TeacherList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleToggleRecipient = this.handleToggleRecipient.bind(this); // toggle single recipient
    this.handleToggleAllPagedRecipients = this.handleToggleAllPagedRecipients.bind(this); // toggle all recipients in page
    this.arePagedRecipientsAllSelected = this.arePagedRecipientsAllSelected.bind(this); // are all recipients in this page selected?
    this.handleRecipientListUpdate = this.handleRecipientListUpdate.bind(this);
  }

  arePagedRecipientsAllSelected() {
    let allSelected = true;

    for (let i=0; i<this.props.teachers.length; i++) {
      const teacher = this.props.teachers[i];

      if (this.props.recipientList[teacher.teacher_key] == undefined) {
        allSelected = false;

        break;
      }
    }

    return allSelected;
  }

  handleToggleRecipient(recipient) {
    let recipients = this.props.recipientList;

    if (recipients[recipient.id]) {
      delete recipients[recipient.id];
    } else {
      recipients[recipient.id] = recipient;
    }

    return this.handleRecipientListUpdate(recipients);
  }

  // NOTE: this function requires recipients as parameters instead of getting it from props so that we can share this function across schools/teachers
  handleToggleAllPagedRecipients(e, nextRecipients) {
    const shouldCheckNotUncheck = e.currentTarget.checked;
    let recipients = this.props.recipientList;

    nextRecipients.forEach((recipient) => {
      if (shouldCheckNotUncheck) {
        recipients[recipient.id] = recipient;
      } else {
        delete recipients[recipient.id];
      }
    });

    this.handleRecipientListUpdate(recipients);
  }

  handleRecipientListUpdate(recipients) {
    if (this.props.onRecipientListUpdate) {
      this.props.onRecipientListUpdate(recipients, 'teachers');
    }
  }

  render() {
    var rows = [];

    if (this.props.teachers) {
      for (let i=0; i<this.props.teachers.length; i++) {
        let teacher = this.props.teachers[i];
        const hasRecipient = this.props.recipientList[teacher.teacher_key] != undefined;

        rows.push(
          <TeacherListItem
            teacher={teacher}

            hasRecipient={hasRecipient}
            onToggleRecipient={this.props.onRecipientListUpdate ? (e) => {
              this.handleToggleRecipient(teacher)
            } : null}
          />
        );
      }
    }

    const checked = this.arePagedRecipientsAllSelected();

    return (
      <table width="100%" border="0">
        <thead>
          {
            this.props.onRecipientListUpdate ? (
              <td colspan="7">
                <input type="checkbox" checked={checked ? 'checked' : false} onClick={this.props.onRecipientListUpdate ? (e) => this.handleToggleAllPagedRecipients(e, this.props.teachers) : null} className="mr-1" /> {!checked ? 'seleziona' : 'deseleziona'} tutti
              </td>
            ) : ''
          }
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    );
  }
}

export default TeacherList;


// WEBPACK FOOTER //
// ./src/components/teachers/TeacherList.js